<template>
  <div class="flex h-full justify-center bg-gray-900 pt-1">
    <div class="flex-grow border-t border-gray-600 bg-gray-800">
      <ul class="ml-1 flex-static flex font-hairline text-xs justify-center relative float-right">
        <li class="-mb-px">
          <button @click='worldScale = true' :class="makeClasses(true)">
            <border-outside />
          </button>
        </li>
        <li>
          <button @click='worldScale = false' :class="makeClasses(false)">
            <border-inside />
          </button>
        </li>
      </ul>
      <div class="pbc-transform-property-type-header">{{worldScale ? 'World Scale' : 'Local Scale'}}</div>
      <my-scale class="bg-gray-800" v-if='worldScale' v-model='value.scale' @change="onChangeWorld" />
      <my-scale class="bg-gray-800" v-else v-model='value.localScale' @change="onChangeLocal" />
    </div>
  </div>

</template>
<script>
import BorderInside from '@icons/BorderInside.vue';
import BorderOutside from '@icons/BorderOutside.vue';
import ToggleSwitch from '@ui/atoms/ToggleSwitch.vue';
import MyScale from '@ui/atoms/Scale.vue';
export default {
  props:{
    value:{
      type:Object,
      required:true
    }
  },
  data() {
    return {
      worldScale:true
    }
  },
  components:{
    MyScale,
    BorderInside,
    BorderOutside
  },
  methods : { 
    onChangeLocal(nv, ov) {
      this.$emit("change-local", nv, ov);
    },
    onChangeWorld(nv, ov) {
      this.$emit("change-world", nv, ov);
    },
    makeClasses(worldScale) {
      const classes = "inline-block border-gray-600 border-l border-t border-b rounded-l py-1 px-1 mb-1 font-semibold".split(" ");
      if (worldScale && this.worldScale) {
        classes.push('text-gray-300');
        classes.push('bg-gray-800');
      } else if (!worldScale && !this.worldScale) {
        classes.push('text-gray-300');
        classes.push('bg-gray-800');
      } else {
        classes.push('text-gray-500');
        classes.push('bg-gray-900');
      }
      return classes;
    }
  }

}
</script>
